import React, { forwardRef } from 'react'
import classnames from 'classnames/bind'
import styles from './styles.scss'
const cx = classnames.bind(styles)

/**
 * This is used to wrap each item in the RankList component.
 * Used internally by RankList, to ensure a ref is tracked for each item.
 */

interface RankItemWrapperProps {
  id: string
  children: React.ReactNode
}

const RankItemWrapper: React.ForwardRefRenderFunction<
  HTMLDivElement,
  RankItemWrapperProps
> = ({ children, id }, ref) => {
  return (
    <div key={id} id={id} ref={ref} className={cx('rank-item')}>
      {children}
    </div>
  )
}

export default forwardRef(RankItemWrapper)
